import { AfterViewInit, Directive, ElementRef, OnDestroy } from '@angular/core';
import { FooterStickyModalService } from '@core/services/footer-sticky-modal/footer-sticky-modal.service';

/**
 * Directive to mark elements as footer sticky modals
 * Automatically registers and unregisters the element with FooterStickyModalService
 * to track its height and adjust page padding accordingly
 *
 * Usage: <div class="fixed bottom-0 ..." appFooterStickyModal>...</div>
 */
@Directive({
  selector: '[appFooterStickyModal]',
  standalone: true,
})
export class FooterStickyModalDirective implements AfterViewInit, OnDestroy {
  private modalId: string;

  constructor(
    private elementRef: ElementRef<HTMLElement>,
    private footerStickyModalService: FooterStickyModalService,
  ) {
    // Generate unique ID for this modal instance
    this.modalId = `modal-${Math.random().toString(36).substring(2, 11)}`;
  }

  ngAfterViewInit(): void {
    // Wait for next tick to ensure element is fully rendered
    setTimeout(() => {
      this.footerStickyModalService.registerModal(this.modalId, this.elementRef.nativeElement);
    }, 0);
  }

  ngOnDestroy(): void {
    // Unregister when component is destroyed
    this.footerStickyModalService.unregisterModal(this.modalId);
  }
}
